import React from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { BarChart as BarChartIcon } from "@mui/icons-material";
import { COLORS } from "../../../styles/uiConstants";
import EmptyState from "../../atoms/EmptyState";
import { formatToken } from "./tokenChartTheme";

/**
 * Yatay çubuk listesi — pasta grafiğin yerine.
 *
 * Pasta 6 dilimde büyüklük karşılaştırmasını imkânsız kılıyordu; yatay çubuk
 * hem sıralamayı hem oranı doğrudan okutur. Değerler her satırda YAZILI olduğu
 * için kimlik renge bağlı değildir.
 *
 * @param {Object[]} items `{ key, label, value, color, note? }` — value POZİTİF
 * @param {string} [emptyMessage]
 */
export default function TokenBarList({ items = [], emptyMessage = "Henüz veri yok", showPercent = true }) {
  const max = items.reduce((m, it) => Math.max(m, Math.abs(it.value || 0)), 0);
  const total = items.reduce((s, it) => s + Math.abs(it.value || 0), 0);

  if (items.length === 0 || max === 0) {
    return (
      <EmptyState variant="compact" icon={<BarChartIcon />} title={emptyMessage} sx={{ py: 5 }} />
    );
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.25 }}>
      {items.map((item) => {
        const value = Math.abs(item.value || 0);
        const widthPct = max > 0 ? Math.max(2, (value / max) * 100) : 0;
        const sharePct = total > 0 ? Math.round((value / total) * 100) : 0;

        return (
          <Tooltip
            key={item.key}
            title={`${item.label}: ${formatToken(value)} token${item.note ? ` · ${item.note}` : ""}`}
            placement="top"
            arrow
          >
            <Box>
              <Box sx={{ display: "flex", alignItems: "baseline", gap: 1, mb: 0.5 }}>
                <Box
                  sx={{
                    width: 8,
                    height: 8,
                    borderRadius: "2px",
                    bgcolor: item.color,
                    flexShrink: 0,
                    alignSelf: "center",
                  }}
                />
                <Typography
                  sx={{ flex: 1, minWidth: 0, fontSize: "0.8125rem", fontWeight: 600, color: COLORS.slate700 }}
                  noWrap
                >
                  {item.label}
                </Typography>
                <Typography sx={{ fontSize: "0.8125rem", fontWeight: 700, color: COLORS.slate800 }}>
                  {formatToken(value)}
                </Typography>
                {showPercent ? (
                  <Typography
                    sx={{ fontSize: "0.6875rem", fontWeight: 600, color: COLORS.slate400, minWidth: 32, textAlign: "right" }}
                  >
                    %{sharePct}
                  </Typography>
                ) : null}
              </Box>

              <Box sx={{ height: 8, borderRadius: 999, bgcolor: COLORS.slate100, overflow: "hidden" }}>
                <Box
                  sx={{
                    width: `${widthPct}%`,
                    height: "100%",
                    borderRadius: 999,
                    bgcolor: item.color,
                    border: `1px solid ${alpha(item.color, 0.001)}`,
                  }}
                />
              </Box>

              {item.note ? (
                <Typography sx={{ fontSize: "0.6875rem", color: COLORS.slate400, mt: 0.25 }}>
                  {item.note}
                </Typography>
              ) : null}
            </Box>
          </Tooltip>
        );
      })}
    </Box>
  );
}
